import styled from "styled-components";

export const StyledElipsisTextSpan = styled.span`
  display: block;
  flex: 0 1 auto;
  min-width: 24px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledElipsisMultiTextDiv = styled.div`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: ${({ width }) => width}px;
`;

export const StyledTooltipTrigger = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 6px;
`;
